<template>
  <div class="download">
    <div class="mobile" v-if="isMobile">
      <div class="content">
        <div class="cell">
          <div class="text-bold">
            <div class="logo"></div>
            房贷计算器
            <div class="small">APP</div>
          </div>
          <div class="info">计算商业贷房贷的还款金额、月供、利息</div>
          <div class="button" @click="downLoadApp">立即下载app</div>
        </div>
      </div>
    </div>
    <div class="pc" v-else>
      <div class="section">
        <div class="logo"></div>
        <div class="title">房贷计算器</div>
      </div>
      <div class="shell">
        <div class="range">
          <div class="content">
            <div class="cell">
              <div class="text-bold">
                房贷计算器
                <div class="small">APP</div>
              </div>
              <div class="info">计算商业贷房贷的还款金额、月供、利息</div>
              <div class="group">
                <img src="../assets/img/mcQrcode.png" />
                <div class="button" @click="downLoadApp">立即下载app</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="../assets/img/home-01-434x642.png" class="mobileImage" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
      name: "",
      isMobile: true,
    };
  },
  created() {
    this.getConfig();
    if (navigator.userAgent.indexOf("Mobile") === -1) {
      this.isMobile = false;
    }
  },
  methods: {
    getConfig() {
      this.$http.get(`/loan/getConfig?name=GJJ_DOWNLOAD_URL`).then((res) => {
        this.url = res.data.GJJ_DOWNLOAD_URL;
      });
    },
    downLoadApp() {
      window.location.href = this.url;
    },
  },
};
</script>

<style lang="scss">
.download {
  background: linear-gradient(
      to right,
      rgb(0, 201, 253) 0%,
      rgb(129, 238, 142) 100%
    )
    0px 0px repeat scroll rgba(0, 0, 0, 0);

  .mobile {
    min-height: 100vh;

    .content {
      color: #fff;

      .cell {
        text-align: center;
        position: relative;
        z-index: 1;
        padding: 80px 15px;

        .text-bold {
          font-weight: 500;
          margin-bottom: 21px;
          font-size: 36px;

          .logo {
            margin-right: 5px;
            display: inline-block;
          }

          .small {
            font-size: 75%;
            font-weight: normal;
            line-height: 1;
            color: #f2f2f2;
          }
        }

        .info {
          margin-top: 34px;
          font-size: 18px;
          line-height: 1.5;
        }
      }
    }
  }

  .button {
    width: 250px;
    line-height: 47px;
    margin: auto;
    margin-top: 66px;
    font-size: 18px;
    color: #ff8439;
    border: 1px solid #ff8439;
    background-color: #fff;
    text-align: center;
    border-radius: 50px;
    padding: 8px 10px;
    cursor: pointer;
  }

  .logo {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-image: url("../assets/img/mcLogo.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  .pc {
    .section {
      position: absolute;
      top: 20px;
      left: 67px;
      display: flex;
      flex-wrap: nowrap;

      .title {
        color: #fff;
        font-size: 26px;
        margin-left: 5px;
      }
    }

    .shell {
      padding: 0 15px;
      margin: auto;
      max-width: 1200px;

      .range {
        margin: 0 -15px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;

        .content {
          min-height: 100vh;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          flex-basis: 100%;
          max-width: 100%;
          color: #fff;

          .cell {
            text-align: left;
            flex-basis: 32%;
            max-width: 32%;
            position: relative;
            z-index: 1;
            padding: 80px 15px;

            .text-bold {
              font-weight: 700;
              margin-bottom: 21px;
              font-size: 64px;

              .small {
                font-size: 75%;
                font-weight: normal;
                line-height: 1;
                color: #f2f2f2;
              }
            }

            .info {
              margin-top: 34px;
              font-size: 18px;
              line-height: 1.5;
            }

            .group {
              margin-top: 55px;
              display: flex;
              flex-wrap: nowrap;

              img {
                width: 120px;
                height: 120px;
              }

              .button {
                margin-left: 20px;
                transform: translateY(-20px);
              }
            }
          }
        }
      }
    }

    .mobileImage {
      display: block;
      position: absolute;
      bottom: 0px;
      left: calc(50% + 75px);
      width: 434px;
      height: 642px;
    }
  }
}
</style>
